import React from "react";
import { motion } from "framer-motion";

const IMG = "/amme/interior-3.jpg";

export const Philosophy = ({ t }) => {
  return (
    <section
      data-testid="philosophy-section"
      className="relative bg-[#e7e7e5] py-32 md:py-48"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-4 md:pt-8"
          >
            <p className="text-[11px] uppercase tracking-[0.4em] text-stone-500 mb-6">
              — {t.philosophy.label}
            </p>
            <div className="aspect-[3/4] w-full max-w-xs overflow-hidden bg-stone-200">
              <img
                src={IMG}
                alt="Ritual"
                className="w-full h-full object-cover"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1.2, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="md:col-span-8 md:pl-8 lg:pl-16"
          >
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] text-stone-900 tracking-tight">
              {t.philosophy.heading}{" "}
              <span className="italic text-[#3d3d3b]">
                {t.philosophy.headingItalic}
              </span>
            </h2>

            <div className="mt-10 md:mt-14 max-w-2xl space-y-6">
              <p className="text-stone-700 text-base md:text-lg font-light leading-[1.8]">
                {t.philosophy.body}
              </p>
              <p className="text-stone-600 text-base md:text-lg font-light leading-[1.8] italic">
                {t.philosophy.body2}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
